<div class="file-upload-block">
    <h5 class="file-upload-heading">{{heading|translate}}</h5>
    <div class="row gutters-5 align-items-center">
      <div class="col upload-image">
        <div
          *ngIf="imgPath && imgType === 'Favicon'"
          class="favicon-preview-frame"
        >
          <img
            class="favicon-preview"
            [src]="imgPath"
            width="56"
            height="56"
            alt=""
          />
        </div>
        <img
          *ngIf="imgPath && imgType === 'Profile'"
          class="favicon-preview rounded-circle profile-preview"
          [src]="imgPath"
          width="56"
          height="56"
          alt=""
        />
        <div
          *ngIf="imgPath && imgType === 'Logo-Light'"
          class="logo-preview-frame logo-preview-frame--dark"
        >
          <img
            class="logo-preview"
            [src]="imgPath"
            alt=""
          />
        </div>
        <div
          *ngIf="imgPath && imgType === 'Logo-Dark'"
          class="logo-preview-frame logo-preview-frame--light"
        >
          <img
            class="logo-preview"
            [src]="imgPath"
            alt=""
          />
        </div>
      </div>
      <div class="col-auto btn-file" *ngIf="isEditPermission">
        <label
          for="{{uniqueID|translate}}"
          class="btn d-block w-100 btn-file-upload mb-2"
        >
          {{"Upload"|translate}}
          <img
            src="../assets/images/icons/upload-icon.png"
            alt=""
            aria-hidden="true"
            (click)="onUploadBtnClick()"
          />
        </label>
        <input
          #fileInput
          type="file"
          id="{{uniqueID}}"
          [accept]="acceptedImageAccept"
          style="display: none"
          (change)="onFileChange($event)"
        />
        <button
          (click)="onFileReset()"
          type="button"
          class="btn d-block w-100 btn-file-remove"
        >
          {{"Remove"|translate}}
          <img
            src="../assets/images/icons/close-icon.png"
            alt=""
            aria-hidden="true"
          />
        </button>
      </div>
    </div>
  </div>
